import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import api from "../../../api";
import moment from 'moment';
import { format, formatCurrency } from '../../../functions/functions';

class ModalEditCuotas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estado: '',
            nroCuota: '',
            moneda: null,
            monto: 0,
            vencimiento: null,
            postVariables: ['nroCuota', 'vencimiento', 'monto'],
        }
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['EDIT', 'DETAIL']).isRequired,
    }

    resetForm() {
        this.setState({
            estado: '',
            nroCuota: '',
            moneda: null,
            monto: 0,
            vencimiento: null,
        });
    }

    getData() {
        const { postVariables, vencimiento} = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.vencimiento = vencimiento ? moment(vencimiento).format('YYYY-MM-DD') : null;
        return data;
    }

    setData(data) {
        if (this.props.action === 'EDIT' && (data.estado === 'PAGA' && data.nroCuota != 0)) {
            return { allowed: false, message: 'Esta cuota ya fue pagada anteriormente.' }
        }

        if (data.success) {
            this.setState({
                estado: data.estado,
                nroCuota: data.nroCuota,
                moneda: data.moneda,
                monto: data.monto,
                vencimiento: moment(data.vencimiento),
            });
        }
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    setErrors(errors) {
        this.setState({ errors });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "EDIT") {
            return {
                get: true,
                submitType: "PATCH",
                title: "Editar cuota",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La cuota ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "btn-success",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: "",
                title: "Cuota",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
                closeButtonLabel: "Cerrar"
            };
        }
    }

    render() {
        const vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        const { 
            estado,
            moneda,
        } = this.state;

        return (
            <ParadigmaModal
                getUrl={vars.get ? api.servicios.editcuotas.replace('$id', this.props.idServicio()) : null}
                submitUrl={vars.submitType ? api.servicios.editcuotas.replace('$id', this.props.idServicio()) : null}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}
                cancelButtonLabel={vars.closeButtonLabel}
                className="ui-paradigma-modal"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la cuota</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Nro."}
                            maxLength={30}
                            value={String(this.state.nroCuota)}
                            error={() => this.getError('nroCuota')}
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Vencimiento"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={vars.disabled}
                                    value={this.state.vencimiento}
                                    onChange={e => this.setState({vencimiento: e})}
                                    error={() => this.getError('vencimiento')}
                                />
                            }
                        />
                        {(estado == "IMPAGA") &&
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Monto"}
                                inputComponent={
                                    <ParadigmaCurrencyInput
                                        disabled={vars.disabled}
                                        className="form-control monto w-100"
                                        symbol={moneda ? moneda.simbolo : ""}
                                        value={formatCurrency(this.state.monto)}
                                        onChange={data => this.onChangeField('monto', data)}
                                    />
                                }
                                error = {()=>this.getError('monto')}
                            />
                        }
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default ModalEditCuotas;



// WEBPACK FOOTER //
// ./src/views/Servicios/Servicios/ModalEditCuotas.js